Vue.component('ack-pac-dent-product', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-pac-dent-product',
    created() {

      // this.selectedVariant = {
      //   id: this.$t(`resins.collection.${this.productId}.variants.0.id`),
      //   label: this.$t(`resins.collection.${this.productId}.variants.0.label`),
      //   bottle_img: this.$t(`resins.collection.${this.productId}.variants.0.bottle_img`),
      // }

      this.selectedVariant = { value: this.variants[0].id, label: this.variants[0].title}

    },
    mounted() {


    },
    props:{
      productId:{
        type: String,
        required: true
      },
      productShopify:{
        type: Object,
        required: true
      },
      menuItems: { // :product-info
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...Vuex.mapGetters('shop', ['isStoreAvailable']),
      featuresList(){
        let list = []
        let fNum = parseInt(this.$t(`pac_dent.collection.${this.productId}.bullet_points_count`))
        for (let index = 0; index < fNum; index++) {
          const feature = this.$t(`pac_dent.collection.${this.productId}.bullet_points.${index}`)
          list.push(feature)
        }
        return list
      },
      kitContainsList(){
        let list = []
        let fNum = parseInt(this.$t(`pac_dent.collection.${this.productId}.bullet_points_kit_count`))
        for (let index = 0; index < fNum; index++) {
          const feature = this.$t(`pac_dent.collection.${this.productId}.bullet_points_kit.${index}`)
          list.push(feature)
        }
        return list
      },

      rowClass() {
        const urls = ['technical_specifications_url', 'instructions_for_use_url', 'safety_data_sheet_url']
        return urls.filter(url => this.getUrl(url)).length === 1 ? 'justify-content-center' : 'justify-content-start'
      },
      
      imageSrc(){
        if(this.variants.length < 2){
          return this.productShopify.images[0]
        } else{
          let selectedVariant = this.variants.find(m=>{
            return m.id == this.selectedVariant.value
          })
          return selectedVariant.featured_image.src
        }
      },

      chartsImages() {
        let list = []
        let fNum = parseInt(this.$t(`pac_dent.collection.${this.productId}.mechanical_properties_count`))
        for (let index = 0; index < fNum; index++) {
          const image = this.$t(`pac_dent.collection.${this.productId}.mechanical_properties.${index}.image`)
          list.push(image)
        }
        return list
      },

      chartsLabels(){
        let list = []
        // 
        let fNum = parseInt(this.$t(`pac_dent.collection.${this.productId}.mechanical_properties_count`))
        for (let index = 0; index < fNum; index++) {
          const label =  this.$t(`pac_dent.collection.${this.productId}.mechanical_properties.${index}.label`)
          list.push(label)
        }
        return list
      },
      charts(){
        let list = []
        // 
        let fNum = parseInt(this.$t(`pac_dent.collection.${this.productId}.mechanical_properties_count`))
        for (let index = 0; index < fNum; index++) {
          const chart = {
            color: this.$t(`pac_dent.collection.${this.productId}.color`),
            //label: this.$t(`resins.collection.${this.productId}.mechanical_properties.${index}.label`),
            value: this.$t(`pac_dent.collection.${this.productId}.mechanical_properties.${index}.value`)
          }
          list.push(ChartOptions.getChartOptions(chart))
        }
        return list
      },

      variants(){
        return this.productShopify.variants
      },
      selectVariantsOptions(){
        let list = []
        for (let index = 0; index < this.variants.length; index++) {
          const element = this.variants[index]
          let opt = {
            label: element.title,
            value: element.id
          }
          list.push(opt)
        }
        return list
      },

      hasItems() {
        return this.$t('pac_dent.collection.' + this.productId + '.technical_specifications_url') ||
               this.$t('pac_dent.collection.' + this.productId + '.instructions_for_use_url') ||
               this.$t('pac_dent.collection.' + this.productId + '.safety_data_sheet_url');
      }
    },
    data() {
      return {
        selectedVariant: null,
        quantity: 1,
        iconColor: '#000000',
        showMenu: true,
        showModal: false,
      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      ...Vuex.mapActions('shop', ['buyNow', 'addToCartFromProperties']),
      onIncreaseQuantityClick() {
        this.quantity++
      },
      onDecreaseQuantityClick() {
        if (this.quantity > 1) {
          this.quantity--
        }
      },
      onBuyNowClick(){
        this.buyNow({variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`, quantity: this.quantity})
        .then((url)=>{
          window.open(url, '_blank')
        })
      },

      onAddToCartClick(){
        this.addToCartFromProperties({productId: `gid://shopify/Product/${this.productId}`, variantId: `gid://shopify/ProductVariant/${this.selectedVariant.value}`, quantity: this.quantity })
      },

      onResinMenuItemClick(item){
        this.$emit('resin-menu-item-click', item)
      },

      getUrl(key) {
        const url = this.$t('pac_dent.collection.' + this.productId + '.' + key)
        return url !== 'pac_dent.collection.' + this.productId + '.' + key ? url : null
      }

    },
    beforeDestroy() {

    },
    watch: {
      productId: {
        handler() {
          this.selectedVariant = { value: this.variants[0].id, label: this.variants[0].title}

        },
        deep: false
      }
    }
  })